import Layout from './Layout'

export default Layout



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/components/Layout/index.js